import '@/scss/common/tabs.scss'
import './grid-tabs.scss'
import type { GridElement } from '@omnia/ui/src/lib/cms/grid/interfaces/gridElement'
import type { TabData } from '@vista-digital/occ-ui'
import { Tabs, TabsDisplayType } from '@vista-digital/occ-ui'
import { type FC, useMemo, useState } from 'react'
import { GridRowComponent } from '@/features/grid/GridRowComponent'
import type { CurzonGridRow } from '../grid.types'

interface GridTab {
    name: string
    grid: CurzonGridRow[] | undefined
}

export const TabLayout: FC<CurzonGridRow> = props => {
    const gridTabElements = useMemo(
        () => props.columns[0].elements.filter(e => e.type === 'gridTab') as Array<GridElement<GridTab>>,
        [props.columns]
    )

    const tabList: TabData[] = useMemo(
        () =>
            gridTabElements.map(e => {
                return { label: e.value.name, value: e.value.name }
            }),
        [gridTabElements]
    )

    const [selectedTab, setSelectedTab] = useState(tabList[0])

    const selectedGrid = useMemo(() => {
        return gridTabElements.find(e => e.value.name === selectedTab.value)?.value.grid
    }, [gridTabElements, selectedTab.value])

    const tabBackground = props.config?.background?.label ? `tab-bg-${props.config.background.label}` : 'tab-bg-white'
    const isWhiteBackGround = tabBackground === 'tab-bg-white'
    const classes = `container-lg-padding grid-tabs ${isWhiteBackGround && 'grid-row'} ${tabBackground}`

    return (
        <>
            <div className={classes} data-testid="tab-layout-tabs">
                <Tabs
                    centered
                    displayType={TabsDisplayType.Primary}
                    tabList={tabList}
                    selectedTab={selectedTab}
                    onTabSelected={tab => setSelectedTab(tab)}
                />
            </div>
            {selectedGrid?.map((row, index) => (
                <GridRowComponent key={'grid-row-' + index} {...row} additionalData={props.additionalData} />
            ))}
        </>
    )
}
